import React, { Component } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';

class PaymentFailure extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorDetails: null,
            isLoading: false
        };
        this.toast = React.createRef();
    }

    componentDidMount() {
        this.extractErrorDetails();
    }

    extractErrorDetails = () => {
        try {
            const urlParams = new URLSearchParams(window.location.search);

            const errorDetails = {
                status: urlParams.get('status'),
                txnId: urlParams.get('txnId'),
                error: urlParams.get('error'),
                message: urlParams.get('message'),
                timestamp: new Date().toISOString()
            };

            console.log('Extracted error details:', errorDetails);
            this.setState({ errorDetails });
        } catch (error) {
            console.error('Error extracting error details:', error);
            this.showToast('error', 'Error', 'Failed to load error details');
        }
    };

    showToast = (severity, summary, detail) => {
        if (this.toast.current) {
            this.toast.current.show({ severity, summary, detail, life: 5000 });
        }
    };

    getErrorMessage = (errorCode) => {
        const errorMessages = {
            'OTS0601': 'Missing transaction ID',
            'OTS0615': 'Missing mandatory parameters',
            'OTS0631': 'Invalid card number',
            'OTS0633': 'Card expired',
            'MISSING_PARAMS': 'Required parameters are missing',
            'INVALID_MERCHANT': 'Invalid merchant configuration',
            'DECRYPT_FAILED': 'Failed to process payment response',
            'SIGNATURE_FAILED': 'Payment verification failed',
            'SIGNATURE_ERROR': 'Error verifying payment',
            'PROCESSING_ERROR': 'Error processing payment'
        };

        return errorMessages[errorCode] || 'Payment failed due to an unknown error';
    };

    retryPayment = () => {
        // Go back to the previous page or payment initiation page
        window.history.back();
    };

    render() {
        const { errorDetails } = this.state;

        if (!errorDetails) {
            return (
                <div className="payment-failure-container p-4">
                    <div className="flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                        <div className="text-center">
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                            <p className="mt-3">Loading error details...</p>
                        </div>
                    </div>
                </div>
            );
        }

        const userFriendlyMessage = this.getErrorMessage(errorDetails.error);

        return (
            <div className="payment-failure-container p-4">
                <Toast ref={this.toast} />

                <div className="flex justify-content-center">
                    <Card
                        title="Payment Failed"
                        style={{ width: '600px' }}
                        className="border-danger"
                    >
                        <div className="text-center mb-4">
                            <i className="pi pi-times-circle text-danger" style={{ fontSize: '4rem' }}></i>
                            <h3 className="text-danger mt-3">Payment could not be processed</h3>
                            <p className="text-muted mt-3">
                                {userFriendlyMessage}
                            </p>
                        </div>

                        <div className="mt-4">
                            <h5 className="mb-3">Error Details</h5>
                            <DataTable value={[
                                { label: 'Transaction ID', value: errorDetails.txnId || 'N/A' },
                                { label: 'Error Code', value: errorDetails.error || 'UNKNOWN' },
                                { label: 'Error Message', value: decodeURIComponent(errorDetails.message || 'Unknown error occurred') },
                                { label: 'Status', value: 'FAILED' },
                                { label: 'Time', value: new Date(errorDetails.timestamp).toLocaleString() }
                            ]} className="mt-2">
                                <Column field="label" header="Field" style={{ fontWeight: 'bold' }}></Column>
                                <Column field="value" header="Value"></Column>
                            </DataTable>
                        </div>

                        <div className="mt-4">
                            <div className="p-message p-message-error">
                                <div className="p-message-wrapper">
                                    <span className="p-message-icon pi pi-exclamation-triangle"></span>
                                    <div className="p-message-text">
                                        <p><strong>What to do next:</strong></p>
                                        <ul className="pl-3 mt-2">
                                            <li>Check your card details and try again</li>
                                            <li>Ensure you have sufficient balance in your account</li>
                                            <li>Try using a different payment method</li>
                                            <li>Contact our support team if the issue persists</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        );
    }
}

export default PaymentFailure;
